import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

import utils from './utils';

const StateOrProvinceSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setPlace = (e, { value }) => {
        dispatch(filterActionCreators.setStateOrProvince(value));
    };

    const countryData = useSelector((state) => state.config.countryData);
    const selectedCountry = useSelector((state) => state.playersAndTeams.filter.values.nationalityCode);
    const selectedPlace = useSelector((state) => state.playersAndTeams.filter.values.birthStateProvinceCode);

    const allBirthLocationsLabel = intl.formatMessage(commonMessages.advancedFilters['birthStateProvinceCode.all']);
    const options = utils.getOptions(countryData, selectedCountry, allBirthLocationsLabel);

    const value = options.find((obj) => obj.value === selectedPlace);
    const disabled = selectedCountry && options.length <= 1;

    return (
        <Select
            onOptionChange={setPlace}
            options={options}
            selectedOption={value}
            isSelectDisabled={disabled}
            isSearchEnabled
            groupBy={(option) => option.country}
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(StateOrProvinceSelect);
